import { Box, Button, Grid2 as Grid, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Mobilelogo from '../assets/MobileLogo.png';
import SendBtnDesktop from '../assets/sendBtn_Desktop.png';
import app_store from '../assets/as.png';
import call from '../assets/call.png';
import fb from '../assets/fb.png';
import google_play from '../assets/googlestore.png';
import insta from '../assets/insta.png';
import iphone from '../assets/iphone.png';
import linkedin from '../assets/in.png';
import locationImg from '../assets/location_on.png';
import logo from '../assets/cv-logo.png';
import mail from '../assets/email.png';
import sendBtn from '../assets/SendBtn.png';
import sendEmailBg from '../assets/sendEmailBg.png';
import sendEmailBgDesktop from '../assets/sendemailbg_desktop.png';
import message_BoxDesktop from '../assets/message_box_desk.png';
import message_box from '../assets/msg_box.png';

import { Link, NavLink, useLocation } from 'react-router-dom';
import { Padding } from '@mui/icons-material';

const Footer = React.forwardRef((props, ref) => {
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width:600px)');
  const imgWidth = isMobile ? '24%' : '40%';
  const iconWidth = isMobile ? '100%' : '150%';
  const footerRef = useRef<HTMLDivElement | null>(null);
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const isHomePage = location.pathname === '/';
  const [delayedShow, setDelayedShow] = useState(false);
  const [showComingSoon, setShowComingSoon] = React.useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    if (showComingSoon) {
      setDelayedShow(true);

      timer = setTimeout(() => {
        setDelayedShow(false);
        setShowComingSoon(false);
      }, 3000);
    }

    return () => clearTimeout(timer);
  }, [showComingSoon]);

  useEffect(() => {
    const scrollToFooter = () => {
      footerRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    window.addEventListener('scrollToFooter', scrollToFooter);
    return () => {
      window.removeEventListener('scrollToFooter', scrollToFooter);
    };
  }, []);

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleMsgChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMsg(event.target.value);
  };

  const handleSendEmail = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SENDMAIL_URL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email,
          message: msg
        })
      });
      const data = await response.json();
      if (response.ok) {
        alert('Email sent successfully!');
      } else {
        alert('Failed to send email. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setEmail('');
      setMsg('');
    }
  };

  return (
    <Box className={'footer-style'} ref={ref} sx={isHomePage && isMobile ? { padding: '0' } : {}}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
        <Typography
          sx={{
            color: 'white',
            fontWeight: isMobile ? '400' : 400,
            letterSpacing: isMobile ? 1 : 3,
            marginBottom: isMobile ? 1 : 3,
            fontFamily: isMobile ? 'Bevan' : 'Bevan',
            paddingTop: isMobile ? '20px' : '60px',
            fontSize: isMobile ? '24px' : '48px',
            margin: '0 40px',
            textAlign: 'center',
            lineHeight: '40px'
          }}>
          {`ARE YOU READY TO MAKE HISTORY ?`}
        </Typography>
      </Box>
      <Typography
        fontFamily="Baloo2"
        ref={footerRef}
        sx={{
          color: 'white',
          m: 'auto',
          width: { xs: '90%', sm: '70%' },
          marginBottom: isMobile ? 1 : 3,
          whiteSpace: 'pre-line',
          fontSize: isMobile ? '13px' : '19px',
          fontWeight: 500,
          textAlign: 'center',
          padding: isMobile ? '10px 30px' : '50px'
        }}>
        Take your experience to the next level with our mobile app! Explore powerful features, unlock new{'\n'}{' '}
        possibilities, and be part of something groundbreaking. Download Now!&quot;
      </Typography>

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          marginTop: 3,
          gap: isMobile ? '20px' : '60px',
          position: 'relative',
          zIndex: 2
        }}>
        {/* App Store Button with "Coming Soon" */}
        <Box sx={{ position: 'relative', zIndex: 3 }} onClick={() => setShowComingSoon(true)}>
          {delayedShow && (
            <Box
              sx={{
                position: 'absolute',
                top: '-50px', // Adjust as needed
                left: '20px',
                backgroundColor: 'black',
                color: 'white',
                padding: '6px 12px',
                borderRadius: '10px',
                fontSize: { xs: '12px', md: '16px' },
                fontFamily: 'Baloo2',
                fontWeight: 800,
                whiteSpace: 'nowrap',
                zIndex: 10,
                boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)'
              }}>
              Coming Soon
            </Box>
          )}
          <img
            src={app_store}
            alt="App Store"
            style={{
              height: isMobile ? '33px' : 'auto',
              width: isMobile ? '130px' : '170px',
              cursor: 'pointer'
            }}
          />
        </Box>

        {/* Google Play Store Button */}
        <Box sx={{ zIndex: 3 }}>
          <a
            href="https://play.google.com/store/apps/details?id=com.champsverse.kidsapp"
            target="_blank"
            rel="noopener noreferrer"
            style={{ pointerEvents: 'auto' }}>
            <img
              src={google_play}
              alt="Google Play Store"
              style={{
                height: isMobile ? '33px' : 'auto',
                width: isMobile ? '130px' : '170px',
                cursor: 'pointer'
              }}
            />
          </a>
        </Box>
      </Grid>

      <Box
        component="footer"
        sx={{
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          marginTop: isMobile ? '8rem' : '2rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'center',
          color: 'white'
        }}>
        <Box
          sx={{
            paddingBottom: isMobile ? 5 : 5,
            textAlign: 'center',
            marginTop: '-20rem',
            paddingLeft: isMobile ? 0 : '10rem'
          }}>
          <Grid container justifyContent="center" alignItems="center" direction="column" spacing={2}>
            {/* App Previews */}
            <Grid columns={{ xs: 12 }}>
              <img
                src={iphone}
                alt="iphone"
                style={{
                  height: isMobile ? '388px' : '900px',
                  width: isMobile ? '518px' : '1200px'
                }}
              />
            </Grid>

            {/* Footer Info */}
          </Grid>
        </Box>
      </Box>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: isMobile ? 'center' : 'space-between',
          marginTop: '-16rem',
          padding: '0 5%',
          background: !isMobile
            ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)'
            : undefined
        }}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}>
          <Typography
            style={{
              fontFamily: 'Bevan',
              fontSize: isMobile ? '24px' : '38px',
              background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              textAlign: 'center'
            }}>
            Ready to get started?
          </Typography>
          <Typography
            style={{
              fontFamily: 'Bevan',
              fontSize: isMobile ? '24px' : '38px',
              background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              textAlign: 'center'
            }}>
            Talk to us today
          </Typography>

          {isMobile && (
            <>
              <TextField
                fullWidth
                placeholder="Enter Your Email Address"
                value={email}
                onChange={handleEmailChange}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      border: 'none'
                    }
                  },
                  '& .MuiInputBase-root': {
                    backgroundImage: `url(${sendEmailBg})`,
                    backgroundSize: '318px 80px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    width: '100%',
                    height: '100%'
                  },
                  input: {
                    textAlign: 'center',
                    fontSize: '16px'
                  },
                  marginTop: '10px'
                }}
              />
              <TextField
                id="message"
                fullWidth={false}
                placeholder="Enter your Message"
                value={msg}
                onChange={handleMsgChange}
                sx={{
                  width: '318px',
                  height: '125px',
                  '& .MuiOutlinedInput-root': {
                    padding: 0,
                    '& fieldset': {
                      border: 'none'
                    }
                  },
                  '& .MuiInputBase-root': {
                    backgroundImage: `url(${message_box})`,
                    backgroundSize: '318px 125px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    width: '318px',
                    height: '125px',
                    padding: '0 8px'
                  },
                  input: {
                    textAlign: 'center',
                    fontSize: '16px'
                  },
                  marginTop: '-1rem'
                }}
              />

              <Button onClick={handleSendEmail} style={{ marginTop: '-2rem' }}>
                <img src={sendBtn} alt="Share" />
              </Button>
            </>
          )}
        </Box>

        {!isMobile && (
          <div
            style={{ position: 'relative', height: '100px', width: '560px', paddingLeft: '8rem', marginTop: '-1rem' }}>
            <TextField
              fullWidth
              placeholder="Enter Your Email Address"
              value={email}
              onChange={handleEmailChange}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    border: 'none'
                  },
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  paddingLeft: '40px'
                },
                '& .MuiInputBase-root': {
                  backgroundImage: `url(${sendEmailBgDesktop})`,
                  backgroundSize: '100% 100%',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  height: '100%'
                },
                input: {
                  padding: '0 20px',
                  textAlign: 'center'
                },
                width: '100%',
                height: '100%',
                marginTop: '0'
              }}
            />
            <TextField
              id="message"
              fullWidth
              placeholder="Enter Your Message"
              value={msg}
              onChange={handleMsgChange}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    border: 'none'
                  },
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  paddingLeft: '20px'
                },
                '& .MuiInputBase-root': {
                  backgroundImage: `url(${message_BoxDesktop})`,
                  backgroundSize: '490px 150px',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  width: '490px',
                  height: '150px'
                },
                input: {
                  padding: '0 20px',
                  textAlign: 'center'
                },
                width: '490px',
                height: '150px',
                marginTop: '-2rem'
              }}
            />
            <Button sx={{ marginTop: '-3rem', padding: '0 9rem' }} onClick={handleSendEmail}>
              <img src={SendBtnDesktop} alt="Send" />
            </Button>
          </div>
        )}
      </Box>
      {!isMobile && (
        <>
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)',
              padding: '2% 5%',
              paddingBottom: '50px'
            }}>
            <Box
              style={{
                width: '40%',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                color: 'white',
                fontSize: '16px',
                fontFamily: 'Baloo2'
              }}>
              <Box style={{ display: 'flex', gap: '15rem' }}>
                <Link to="/about" style={{ textDecoration: 'none' }}>
                  <Typography style={{ color: 'white' }}>ABOUT US</Typography>
                </Link>
                <Link to="/cv-policies" style={{ textDecoration: 'none' }}>
                  <Typography style={{ color: 'white' }}>PRIVACY POLICY</Typography>
                </Link>
              </Box>
              <Box style={{ display: 'flex', gap: '194px' }}>
                <Typography style={{ color: 'white' }}>FAQ</Typography>
                <Link to="/coppa-policies" style={{ textDecoration: 'none' }}>
                  <Typography style={{ color: 'white' }}>COPPA POLICY</Typography>
                </Link>
              </Box>
              <Box style={{ display: 'flex', gap: '62px' }}>
                <Link to="/terms&conditions" style={{ textDecoration: 'none' }}>
                  <Typography style={{ color: 'white' }}>TERMS & CONDITIONS</Typography>
                </Link>
                <Typography style={{ color: 'white' }}>COOKIES POLICY</Typography>
              </Box>
            </Box>
            <Box id="contact">
              {[
                { img: mail, text: 'info@champsverse.com' },
                { img: call, text: '+91 7358380114' }
              ].map((item, index) => (
                <Box
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 0'
                  }}>
                  <img src={item.img} style={{ height: '24px' }} alt="icon" />
                  <Typography
                    style={{
                      color: 'white',
                      fontFamily: 'Baloo2',
                      fontSize: '16px',
                      paddingLeft: '10px'
                    }}>
                    {item.text}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
          <hr style={{ border: '1px solid white', width: '100%' }} />
        </>
      )}

      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          width: '100%',
          background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)',
          padding: '10px 0 0 0'
        }}>
        <img src={logo} alt="logo" width={isMobile ? '50%' : '20%'} style={{ marginLeft: '3%' }} />
        {!isMobile && (
          <Typography style={{ color: 'white', textAlign: 'center', marginLeft: '20%' }}>
            © 2025 champsverse. All rights reserved.
          </Typography>
        )}

        <Box
          style={{
            marginLeft: 'auto',
            display: 'flex',
            gap: '25px',
            paddingRight: '5%'
          }}>
          <NavLink
            to="https://www.instagram.com/champsverse?igsh=MXEwYXJnYTlyNm1yMA=="
            target="_blank"
            rel="noopener noreferrer">
            <img
              src={insta}
              alt="Instagram"
              style={{
                width: isMobile ? '18px' : '24px',
                height: isMobile ? '18px' : '24px'
              }}
            />
          </NavLink>
          <img
            src={fb}
            alt="Facebook"
            style={{
              width: isMobile ? '18px' : '24px',
              height: isMobile ? '18px' : '24px'
            }}
          />
          <img
            src={linkedin}
            alt="LinkedIn"
            style={{
              width: isMobile ? '18px' : '24px',
              height: isMobile ? '18px' : '24px'
            }}
          />
        </Box>
      </Box>
      {/* {isMobile && (
        <Box
          style={{
            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)'
          }}>
          <hr style={{ border: '1px solid white', width: '100%', margin: '5%' }} />
        </Box>
      )} */}
      {isMobile && (
        <Box
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: isMobile ? '10px' : '12px',
            color: 'white',
            fontFamily: 'Baloo2',
            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)'
          }}>
          <hr style={{ border: '1px solid white', width: '90%', margin: '5%' }} />
          <Box
            style={{
              display: 'flex',
              fontSize: '12px',
              gap: '22rem',
              marginLeft: '5%'
            }}>
            <Link to="/about" style={{ textDecoration: 'none' }}>
              <Typography sx={{ fontSize: '12px', fontFamily: 'Baloo2', color: 'white' }}>ABOUT US</Typography>
            </Link>
            <Link to="/cv-policies" style={{ textDecoration: 'none', cursor: 'pointer' }}>
              <Typography sx={{ fontSize: '12px', fontFamily: 'Baloo2', color: 'white' }}>PRIVACY POLICY</Typography>
            </Link>
          </Box>
          <Box
            style={{
              display: 'flex',
              fontSize: isMobile ? '12px' : '16px',
              gap: '25rem',
              marginLeft: '5%'
            }}>
            <Typography sx={{ fontSize: '12px', fontFamily: 'Baloo2' }}>FAQ</Typography>
            <Link to="/coppa-policies" style={{ textDecoration: 'none' }}>
              <Typography sx={{ fontSize: '12px', fontFamily: 'Baloo2', color: 'white' }}>COPPA POLICY</Typography>
            </Link>
          </Box>
          <Box
            style={{
              display: 'flex',
              fontSize: isMobile ? '12px' : '16px',
              gap: '158px',
              marginLeft: '5%'
            }}>
            <Link to="/terms&conditions" style={{ textDecoration: 'none' }}>
              <Typography sx={{ fontSize: '12px', fontFamily: 'Baloo2', color: 'white' }}>
                TERMS & CONDITIONS
              </Typography>
            </Link>

            <Typography sx={{ fontSize: '12px', fontFamily: 'Baloo2', color: 'white' }}>COOKIES POLICY</Typography>
          </Box>
          <hr
            style={{
              border: '1px solid white',
              width: '90%',
              color: 'rgba(255, 255, 255, 0.7)',
              margin: '0 5%'
            }}
          />
          <Box id="contact">
            {[
              { img: mail, text: 'info@champsverse.com' },
              { img: call, text: '+91 7358380114' }
            ].map((item, index) => (
              <Box
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '5px 0',
                  marginLeft: '5%'
                }}>
                <img src={item.img} style={{ height: isMobile ? '19px' : '24px' }} alt="icon" />
                <Typography
                  style={{
                    color: 'white',
                    fontFamily: 'Baloo2',
                    fontSize: isMobile ? '12px' : '16px',
                    paddingLeft: '10px'
                  }}>
                  {item.text}
                </Typography>
              </Box>
            ))}
          </Box>

          <hr
            style={{
              border: '1px solid white',
              width: '90%',
              color: 'rgba(255, 255, 255, 0.7)',
              margin: '0 5%'
            }}
          />
          <Typography style={{ color: 'white', fontSize: '14px', marginLeft: '5%' }}>
            {' '}
            © 2025 champsverse. All rights reserved.
          </Typography>
        </Box>
      )}
    </Box>
  );
});

Footer.displayName = 'Footer';

export default Footer;
